import { render, staticRenderFns } from "./Exercise.vue?vue&type=template&id=25860ee0&scoped=true&"
import script from "./Exercise.vue?vue&type=script&lang=js&"
export * from "./Exercise.vue?vue&type=script&lang=js&"
import style0 from "./Exercise.vue?vue&type=style&index=0&id=25860ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25860ee0",
  null
  
)

export default component.exports